(function () {
  function initStickyATCFooterHide() {
    var atc = document.getElementById('stickyAddToCart');
    if (!atc) return;

    var footer = document.querySelector('footer')
              || document.querySelector('.habba-footer')
              || document.querySelector('.custom-footer')
              || document.querySelector('[id*="shopify-section-footer"] > *')
              || document.querySelector('[id*="shopify-section-footer"]');

    if (!footer) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          atc.style.cssText += ';transform:translateY(110%) !important;opacity:0 !important;pointer-events:none !important;transition:transform 0.3s ease,opacity 0.3s ease !important;';
        } else {
          atc.style.transform = '';
          atc.style.opacity = '';
          atc.style.pointerEvents = '';
        }
      });
    }, { threshold: 0.01 });

    observer.observe(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATCFooterHide);
  } else {
    initStickyATCFooterHide();
  }
})();
